import { TestConfigurationResultViewCommonProps } from "../TestConfigurationResultViewCommonProps";
import i18n from "i18next";
import { ConfiguratorLogApi } from "src/api/generated/erp/configurator/api/configuratorLogApi.ts";
import { ConfiguratorLogView } from "src/components/views/erp/configurator/configuratorTesting/logViews/ConfiguratorLogView.tsx";
import { AavoMosaic } from "src/components/common/mosaic/AavoMosaic.tsx";
import { TestConfigurationAttributeResultsDataGrid } from "src/components/views/erp/configurator/configuratorTesting/attributes/TestConfigurationAttributeResultsDataGrid.tsx";

export const TestConfigurationAttributeResultsWithLogView = (props: TestConfigurationResultViewCommonProps) => {
	const { configuratorType, configurationSessionId } = props;
	return (
		<AavoMosaic
			viewId={"BA20C8376ED45761"}
			layout={{
				type: "row",
				first: {
					type: "panel",
					title: i18n.t("attributes"),
					content: <TestConfigurationAttributeResultsDataGrid {...props} />,
				},
				second: {
					type: "panel",
					title: i18n.t("attribute_log"),
					content: (
						<ConfiguratorLogView
							fetchLogPathBase64={() =>
								ConfiguratorLogApi.getTestConfigurationPhaseResolvingLogBase64Path({
									phase: "ATTRIBUTES",
									sessionId: configurationSessionId,
									configuratorType: configuratorType,
								})
							}
						/>
					),
				},
			}}
		/>
	);
};
